//@flow
import React, { Component } from 'react';
import type { Node } from 'react';
import injectSheet from 'react-jss';
import modalCss from '../styles/modal';
import limitAlert from '../images/limit-alert.svg';
import closeBtn from '../images/close.svg';
import { setSessionIdToUrl, sendTrackingEvent, SessionedLink } from 'h-commons';
import Button from './button';
import SVGInline from 'react-svg-inline';

/**
* This file is responsible for displaying a reusable modal
* @author Hrushikesh
*/
type State = {
    openModal: boolean
}
type Props = {
    classes: Object,
    shown: boolean,
    feature: string,
    limit: number,
    max_threshold: Number,
    handleModalState: Function,
    isMessage: boolean

}

const handleUpgradeClick = (upgradeClickedGainsightEvent) => {
    if (upgradeClickedGainsightEvent) {
        sendTrackingEvent(upgradeClickedGainsightEvent);
    }
}

class UpgradePopup extends Component<Props, State> {
    static defaultProps = {
        isMessage: false
    }

    closeModal(state) {
        this.props.handleModalState(!state);
    }

    getUpgradeLink = () => {
        const { userSession } = this.props;
        const upgradeLink = '/app/settings/account/upgrade';
        return userSession ? setSessionIdToUrl(upgradeLink, userSession) : upgradeLink
    }

    render() {
        const { shown, upgradeClickedGainsightEvent = null, upgradePopupSeenGainsightEvent = null } = this.props;
        if(!shown) {
            return null;
        }

        if (upgradePopupSeenGainsightEvent) {
            sendTrackingEvent(upgradePopupSeenGainsightEvent);
        }

        const { 
            classes,
            feature,
            limit,
            max_threshold,
            isMessage
        } = this.props;
        let containerClass = classes.modalCont
        return (
            <div className={classes.modal}>
                <div className={containerClass} id="limit_exceeded">
                <div id="close-btn-wrapper" onClick={() => this.closeModal(true)}><SVGInline svg={closeBtn} id="close-btn" /></div>
                <SVGInline svg={limitAlert} className={`${classes.icon} h-mr-13p`} id="limit-alert"/>
                    { max_threshold ?
                        <React.Fragment>
                            <div className={classes.modalContent} id="popup-text">
                                You have reached the maximum number of {feature} ({limit}) <br/>allowed in Hiver. Please{isMessage ? ` reduce the number of ${feature} being added or `: ' ' }contact support for further assistance.
                            </div>
                            <div className={classes.modalAction}>
                                <Button
                                    buttonText="Got it"
                                    clickHandler={() => this.closeModal(true)}
                                />
                            </div>
                        </React.Fragment>
                    :
                        <React.Fragment>
                            <div className={classes.modalContent} id="popup-text">
                                You have reached the maximum number of {feature} ({limit}) <br/>allowed in your plan. Please{isMessage ? ` reduce the number of ${feature} being added or `: ' ' }upgrade to avail higher limits.
                            </div>
                            <div className={classes.modalAction}>
                                <SessionedLink to={this.getUpgradeLink()}>
                                    <Button
                                        buttonText="Upgrade Now"
                                        clickHandler={() => handleUpgradeClick(upgradeClickedGainsightEvent)}
                                    />
                                </SessionedLink>
                            </div>    
                        </React.Fragment>             
                    }
                </div>
            </div>
        );
    }
}

export default injectSheet(modalCss)(UpgradePopup);    